module.exports = __webpack_public_path__ + "img/desc5.ba97e408.png";